import React from "react";

// Icone custom de capacete de moto (fechado, com viseira) em estilo line-art
// compativel com o resto da UI lucide-react. Usa currentColor para poder
// herdar cor via classes tailwind (text-sky-500 etc.).
const MotoHelmet = React.forwardRef(function MotoHelmet(
  { size = 24, strokeWidth = 1.8, className = "", ...props },
  ref
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Casco externo: domo + queixeira */}
      <path d="M3.5 13C3.5 7.5 7.3 3.5 12 3.5S20.5 7.5 20.5 13v5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />
      {/* Viseira (area do rosto) — arco superior e inferior */}
      <path d="M5.5 10.2c1.9-1 3.9-1.5 6.5-1.5s4.6.5 6.5 1.5" />
      <path d="M5.5 14.5c1.9.5 4 .9 6.5.9s4.6-.4 6.5-.9" />
      {/* Linha inferior da queixeira */}
      <path d="M9 19h6" />
    </svg>
  );
});

export default MotoHelmet;
